import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import {getCompanyList, getSearchExample} from '../../request/index/company'
import {getToken} from '../../request/common'

export default {
    namespaced: true,
    state: {
        // 企业列表
        listToken: '',
        listKeyWord: '',
        pageNum: 1,
        listData: {
            count: 0,
            list: [],
            time: 0
        },
        listHasUrlParam: false,
        listHasContent: false,
        listSearchExample: {}
    },
    mutations: {
        setList (state, payLoad) {
            state.keyWord = payLoad.kw
            state.pageNum = payLoad.pageNum
            state.listData = payLoad.data
        },
        setListKeyWord (state, kw) {
            state.listKeyWord = kw
        },
        setToken (state, token) {
            state.listToken = token
        },
        setListHasUrlParam (state, isOpen) {
            state.listHasUrlParam = isOpen
        },
        setListHasContent (state, isOpen) {
            state.listHasContent = isOpen
        },
        setListSearchExample (state, data) {
            state.listSearchExample = data
        },
        resetList (state) {
            state.listData = {
                count: 0,
                list: [],
                time: 0
            }
        }
    },
    actions: {
        // payLoad: kw, page
        getList (context, payLoad) {
            // 获取参数
            let companySearchParams = {
                param: {keyword: payLoad.kw, page: payLoad.page, limit: 10},
                token: payLoad.token
            }
            // 请求接口
            return getCompanyList(companySearchParams.param, companySearchParams.token).then(res => {
                if (parseInt(res.code) === 103001) {
                    window.location.href = res.data.jumpUrl
                } else if (res.success) {
                    // 将列表信息和搜索值传入store (这个接口就算返回值是空格式也是正确的,载荷为res.data与searchKw)
                    const payLoad = {
                        kw: companySearchParams.param.keyword,
                        pageNum: companySearchParams.param.page,
                        data: res.data
                    }
                    context.commit('setList', payLoad)
                } else {
                    console.warn('获取企业列表失败')
                }
                return res
            })
        },
        getSearchExample (context, payLoad) {
            // 获取参数
            let searchExampleParams = {
                param: {keyword: payLoad.kw, page: payLoad.page},
                token: payLoad.token
            }
            return getSearchExample(searchExampleParams.param, searchExampleParams.token).then(res => {
                context.commit('setListSearchExample', res.data)
                return res
            })
        },
        getToken (context) {
            return getToken().then(res => {
                if (res.success) {
                    context.commit('setToken', res.data)
                }
                return res
            })
        }
    },
    getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js